{
  "title": "ภาพรวมวันนี้",
  "attention": {
    "title": "แชทรอคนตอบ",
    "sub": "AI ส่งต่อมา ลูกค้าขอคุยกับคน หรือมีออเดอร์รออนุมัติ",
    "countMore": "{{count}}+",
    "openInbox": "เปิดกล่องข้อความ",
    "emptyTitle": "ไม่มีแชทรอคนตอบ",
    "emptyBody": "แชทที่ AI ส่งต่อ ลูกค้าขอคุยกับคน หรือออเดอร์ที่รออนุมัติจะขึ้นที่นี่ ตอบแล้วจะหายไปเอง",
    "loadError": "โหลดแชทที่รอคนตอบไม่สำเร็จ",
    "noPreview": "—"
  },
  "ai": {
    "title": "AI วันนี้",
    "on": "กำลังตอบลูกค้า",
    "off": "ปิดอยู่",
    "used": "ใช้ไป {{percent}}% ของโควตาวันนี้",
    "settings": "ตั้งค่าผู้ช่วย AI",
    "loadError": "โหลดข้อมูล AI ไม่สำเร็จ"
  },
  "orders": {
    "title": "ออเดอร์รอชำระเงิน",
    "viewAll": "ดูออเดอร์ทั้งหมด",
    "emptyTitle": "ไม่มีออเดอร์รอชำระเงิน",
    "emptyBody": "ออเดอร์ที่สร้างจากแชทและยังไม่ได้รับเงินจะขึ้นที่นี่",
    "loadError": "โหลดออเดอร์ไม่สำเร็จ",
    "noCustomer": "ไม่ระบุลูกค้า",
    "items_other": "{{count}} รายการ"
  },
  "channels": {
    "title": "ช่องทางแชท",
    "manage": "จัดการช่องทาง",
    "connected": "เชื่อมต่อแล้ว",
    "reconnect": "ต้องเชื่อมต่อใหม่",
    "inactive": "ปิดอยู่",
    "emptyTitle": "ยังไม่ได้เชื่อมช่องทาง",
    "emptyBody": "เชื่อม LINE OA, Facebook หรือ Instagram เพื่อเริ่มรับแชท",
    "connect": "เชื่อมช่องทาง",
    "loadError": "โหลดช่องทางไม่สำเร็จ"
  },
  "plan": {
    "title": "แพ็กเกจ",
    "manage": "จัดการแพ็กเกจ",
    "daysUnit": "วันที่เหลือ"
  }
}
